import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate, faMobile, faPlug, faTools, faUser, faUsers } from '@fortawesome/free-solid-svg-icons';

import Card from '../../components/widget/Card';

import classes from './Tools.module.css';

const Tools = () => {
    return (
        <div className="row">
            <div className="col-12 col-xl-12 pb-3">
                <Card className={classes.cardBg}>
                    <a href="/admin/perfil">
                        <img src="img/admin/admin-profile.png"
                            className={classes.imgCard}
                            title='Gerência de dados pessoais, senha e preferências da conta.'
                            alt='Gerência de dados pessoais, senha e preferências da conta.'
                        />
                    </a>

                    <a href="/admin/perfil"
                        className="btn btn-primary w-100"
                    >
                        <FontAwesomeIcon icon={faUser} /> PERFIL
                    </a>
                </Card>
            </div>

            <div className="col-12 col-xl-12 pb-3">
                <Card>
                    <a className="img-card" href="/admin/usuarios">
                        <img src="img/admin/admin-accounts.png"
                            className={classes.imgCard}
                            title="Gerência de usuários e permissões de acesso ao sistema."
                            alt="Gerência de usuários e permissões de acesso ao sistema."
                        />
                    </a>

                    <a href="/admin/usuarios"
                        className="btn btn-primary w-100"
                    >
                        <FontAwesomeIcon icon={faUsers} /> USUÁRIOS
                    </a>
                </Card>
            </div>

            <div className="col-12 col-xl-12 pb-3">
                <Card>
                    <a className="img-card" href="/admin/aplicativos">
                        <img src="img/admin/admin-apps.png"
                            className={classes.imgCard}
                            title="Gerência de aplicativos."
                            alt="Gerência de aplicativos."
                        />
                    </a>

                    <a href="/admin/aplicativos"
                        className="btn btn-primary w-100"
                    >
                        <FontAwesomeIcon icon={faMobile} /> APLICATIVOS
                    </a>
                </Card>
            </div>

            <div className="col-12 col-xl-12 pb-3">
                <Card>
                    <a className="img-card" href="/admin/licencas">
                        <img src="img/admin/admin-licenses.png"
                            className={classes.imgCard}
                            title="Gerência de licenças de aplicativos, ativações e validade."
                            alt="Gerência de licenças de aplicativos, ativações e validade."
                        />
                    </a>

                    <a href="/admin/licencas"
                        className="btn btn-primary w-100"
                    >
                        <FontAwesomeIcon icon={faCertificate} /> LICENÇAS
                    </a>
                </Card>
            </div>

            <div className="col-12 col-xl-12 pb-3">
                <Card>
                    <a className="img-card" href="/admin/sistemasexternos">
                        <img src="img/admin/admin-externalsystems.png"
                            className={classes.imgCard}
                            title="Sistemas de terceiros utilizados por nossa equipe."
                            alt="Sistemas de terceiros utilizados por nossa equipe."
                        />
                    </a>

                    <a href="/admin/sistemasexternos"
                        className="btn btn-primary w-100"
                    >
                        <FontAwesomeIcon icon={faPlug} /> SISTEMAS EXTERNOS
                    </a>
                </Card>
            </div>

            <div className="col-12 col-xl-12">
                <Card>
                    <a className="img-card" href="/admin/configuracoes">
                        <img src="img/admin/admin-settings.png"
                            className={classes.imgCard}
                            title="Ajuste de parâmetros globais e integrações do sistema."
                            alt="Ajuste de parâmetros globais e integrações do sistema."
                        />
                    </a>

                    <a href="/admin/configuracoes"
                        className="btn btn-primary w-100"
                    >
                        <FontAwesomeIcon icon={faTools} /> CONFIGURAÇÕES
                    </a>
                </Card>
            </div>
        </div>
    );
};

export default Tools;